///// <reference path="jquery.validate.js" />
///// <reference path="jquery.validate.unobtrusive.js" />  

$.validator.addMethod("checkvat", function (value, element, check) {
    if (value) {

        var url = $(element).attr('data-url');

        var data = {
            vatNumber: value
        };

        var result = ajaxCheckNumber(url, data, element);

        return result;
    }
    else {
        return true;
    }
});  


$.validator.unobtrusive.adapters.add("checkvat", [], function (options) {
    options.rules.checkvat = {};
    options.messages["checkvat"] = options.message;
});


var ajaxCheckNumber = (url, data, element) => {
    var valid = false;

    console.log(url);

    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        async: false,
        success: function (result) {
            console.log(result);
            valid = result.isValid;
        }
    });

    return valid;
}